export default __webpack_public_path__ + "static/media/star.190d870d.png";